import React, { useEffect, useState } from 'react';
import ArrowButtonGroup from './ArrowButtonGroup';
import MenuButtonGroup from './MenuButtonGroup';
import _Radio from '../../../controllers/radio';


const Radio = (props) => {
    const { ModuleRP, vehicle } = props;

    const [radio] = useState(new _Radio(ModuleRP.locale, ModuleRP.userId, vehicle));
    const [, setForceRender] = useState(0);

    ModuleRP.Radio = radio;

    useEffect(() => {
        const update = () => {
            setForceRender((prev) => prev + 1);
        };
        radio.addListener(update);

        return () => {
            radio.listeners = radio.listeners.filter((listener) => listener !== update);
        };
    }, [radio]);

    return (
        <div className="row box_radio">
            <MenuButtonGroup radio={radio} />
            <ArrowButtonGroup radio={radio} />
        </div>
    );
};

export default Radio;
